import { makeAutoObservable } from "mobx";
class CommonStores {
  public timbreList = [];
  public theme = 'light'
  constructor() {
    makeAutoObservable(this);
  }

  public setTimbreList (timbreList) {
    this.timbreList = timbreList;
  }
  public setTheme = (theme: string) => {
    this.theme = theme;
  }
}

const commonStore = new CommonStores();
export default commonStore;
